import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
import colors from "../../../shared/constants/color";
import { withoutBackdropClose } from "../../../utils/dialogClose";

interface IConfirmDialogProps {
    open: boolean;
    title: string;
    message: string;
    onClose: () => void;
    onConfirm: () => void;
}

export const ConfirmDialog: React.FC<IConfirmDialogProps> = ({
    open,
    title,
    message,
    onClose,
    onConfirm,
}) => {
    return (
        <Dialog
          open={open}
          onClose={withoutBackdropClose(onClose)}
          disableScrollLock
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} sx={{ textTransform: "none" }}>
                    Hayır
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    sx={{ textTransform: "none", background: colors.blue.B800 }}
                >
                    Evet
                </Button>
            </DialogActions>
        </Dialog>
    );
};
